import gql from 'graphql-tag'

export const ADD_TRUCK_ORDER = gql`
 mutation insert_truckOrders($id: uuid!,$truckOrderNumber: String!,$truckId: uuid!,$driverId: uuid!, $date: date!,
  $fromCity: String!, $toCity: String!,$commitedWeight: String!, $price: String!, $lrCommision: String!, $ewayBillNo: String, 
  $bookingDate: date!, $createdAt: timestamptz!, $status: String!, $internalstatus: uuid!, $transporterId: uuid!) {
  insert_truckOrders(objects: {id: $id, truckOrderNumber: $truckOrderNumber,truckId: $truckId, driverId: $driverId, date: $date,
   fromCity: $fromCity, toCity: $toCity, commitedWeight: $commitedWeight, price: $price, lrCommision: $lrCommision, ewayBillNo: $ewayBillNo,
   bookingDate: $bookingDate, createdAt: $createdAt, status: $status, internalstatus: $internalstatus, transporterId: $transporterId}) {
    returning {
      id
 }
}
  }
`
export const UPDATE_TRUCK_ORDER = gql`
 mutation ($truckOrderId: uuid!, $truckId: uuid!,$driverId: uuid!, $fromCity: String!, $toCity: String!,$commitedWeight: String!,
  $price: String!, $lrCommision: String!, $ewayBillNo: String, $bookingDate: date!, $truckOrderNumber: String!, $transporterId: uuid!) {
   update_truckOrders (where: {id: {_eq: $truckOrderId}}, _set: {truckId: $truckId, driverId: $driverId,fromCity: $fromCity,truckOrderNumber: $truckOrderNumber,
    toCity: $toCity, commitedWeight: $commitedWeight, price: $price, lrCommision: $lrCommision, ewayBillNo: $ewayBillNo,bookingDate: $bookingDate,transporterId: $transporterId}) {
    returning {
      id
     }
    } 
  }
`
export const DELETE_TRUCK_ORDER = gql`
 mutation ($truckOrderId: uuid!) {
   delete_truckOrders(where: {id: {_eq: $truckOrderId}}) {
    returning {
      id
     }
    }   
  }
`
export const UPDATE_TRUCK_ORDER_STATUS = gql`
 mutation ($truckOrderId: uuid!, $status: String!) {
   update_truckOrders (where: {id: {_eq: $truckOrderId}}, _set: {status: $status}) {
    returning {
      id
     }
    } 
  }
`